import type { Country } from '@/models/country';

/** Returns a copy of the list with the swap pair applied (post-swap window display order). */
export function applyListSwap(
  countryList: Country[],
  swapPair: [number, number] | null | undefined,
): Country[] {
  if (!swapPair) {
    return countryList;
  }
  const result = [...countryList];
  const temp = result[swapPair[0]];
  result[swapPair[0]] = result[swapPair[1]];
  result[swapPair[1]] = temp;
  return result;
}
